import type { UnlistenFn } from '@tauri-apps/api/event'

import { tauriMode } from '@/shared/utils/import-meta'

export const isWindowHidden = async (): Promise<boolean> => {
  const hidden = document.visibilityState === 'hidden'
  if (tauriMode()) {
    const { getCurrentWebviewWindow } = await import('@tauri-apps/api/webviewWindow')
    const isFocused = await getCurrentWebviewWindow().isFocused()
    return hidden || !isFocused || await getCurrentWebviewWindow().isMinimized()
  }
  return hidden
}

export const onWindowVisibilityChange = (callbackFn: (focused: boolean) => void): Promise<UnlistenFn> => {
  if (tauriMode()) {
    return import('@tauri-apps/api/webviewWindow')
      .then(({ getCurrentWebviewWindow }) => getCurrentWebviewWindow().onFocusChanged((event) => callbackFn(event.payload)))
  }

  const callbackToUnListen = () => {
    callbackFn(document.visibilityState === 'visible')
  }
  document.addEventListener('visibilitychange', callbackToUnListen)

  return Promise.resolve(() => document.removeEventListener('visibilitychange', callbackToUnListen))
}
